import { j as a } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const i = r((e, o) => /* @__PURE__ */ a.jsx(
  s,
  {
    ref: o,
    ...e,
    image: (l) => /* @__PURE__ */ a.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...l,
        children: /* @__PURE__ */ a.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M16 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14M5 11C5 4.925 9.925 0 16 0s11 4.925 11 11c0 5.102-3.473 9.392-8.184 10.636-.466.123-.812.532-.812 1.014V23a1 1 0 0 0 1 1H21a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-1.999a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 0-1-1H11a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2.004a1 1 0 0 0 1-1v-.347c0-.483-.347-.892-.814-1.015C8.476 20.396 5 16.104 5 11",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
i.displayName = "FemaleIcon";
export {
  i as FemaleIcon,
  i as default
};
//# sourceMappingURL=index.js.map
